<template>
  <v-menu
    offset-y
    min-width="150"
    max-width="250"
    :close-on-content-click="false"
    dark
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="grey"
        dark
        v-bind="attrs"
        v-on="on"
        :width="full ? '100%' : 'auto'"
        :height="full ? '100%' : 'auto'"
        :rounded="rounded"
        outlined
        class="text-capitalize bold justify-space-between"
        :block="block"
        :small="small"
      >
        {{ $t('settings') }}
        <v-icon right dark>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-container
      dark
      fluid
      class="bg-dark menu-toolbar-settings-content"
      style="background: #1d1d1d; min-height: 200px"
    >
      <v-row dense>
        <v-col cols="12">
          <span class="text-small">
            {{ $t('oddsChanging') }}
          </span>
        </v-col>
        <v-col cols="12" class="no-padding">
          <v-radio-group dense v-model="acceptOdds" mandatory class="mt-0">
            <v-radio dark :label="$t('alwaysAsk')" :value="false"></v-radio>
            <v-radio dark :label="$t('acceptAnyOdds')" :value="true"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12">
          <span class="text-small">
            {{ $t('oddsType') }}
          </span>
        </v-col>
        <v-col cols="12" class="no-padding">
          <v-radio-group dense v-model="oddsType" mandatory class="mt-0">
            <v-radio dark :label="$t('decimal')" value="decimal"></v-radio>
            <v-radio dark :label="$t('american')" value="american"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ToolbarSettings',
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data: () => ({
    openlivesection:
      window.openlivesection != null
        ? window.openlivesection === 'true' || window.openlivesection === true
          ? true
          : false
        : false,
  }),
  created() {},
  mounted() {
    const vm = this

    if (this.openlivesection === true) {
      vm.changeLiveMode('detail')
    }
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters({}),
    acceptOdds: {
      get() {
        return this.$store.state.cart.odds_variation
      },
      set(value) {
        this.$store.commit('cart/SET_ODDS_VARIATION', value)
      },
    },
    oddsType: {
      get() {
        return this.$store.state.odds.odds_type
      },
      set(value) {
        this.$store.commit('odds/SET_ODDS_TYPE', value)
      },
    },
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
      setStatusQbet: 'tree/setStatusQbet',
    }),
    changeLiveMode(mode) {
      this.setStatusQbet(false)
      this.setLiveMode({ mode: mode })
    },
  },
}
</script>

<style scoped></style>
